import { render, staticRenderFns } from "./AppDisplayPost.vue?vue&type=template&id=a1494716&scoped=true&"
import script from "./AppDisplayPost.vue?vue&type=script&lang=js&"
export * from "./AppDisplayPost.vue?vue&type=script&lang=js&"
import style0 from "./AppDisplayPost.vue?vue&type=style&index=0&id=a1494716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1494716",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/AppDisplayPost.vue
// module id = 147
// module chunks = 0